import { useEffect } from "react";
import { useRouteError } from "react-router-dom";
import { ErrorPage } from "@/components/error-page/ErrorPage";
import { useLogger } from "@/hooks/useLogger";
import { serializeError } from "@/utils/log";

/**
 * Router-level error boundary. React Router renders this in place of a route
 * subtree when a render/loader/action throws. Unlike a bare <ErrorPage />, it
 * reports the crash to Datadog (host child logger forwards `error` and above)
 * so unhandled cashier failures are captured, then shows the fallback UI.
 */
export const RouteErrorBoundary = () => {
  const error = useRouteError();
  const logger = useLogger();

  useEffect(() => {
    logger.error("Unhandled cashier render error", {
      event: "render_error",
      error: serializeError(error),
    });
  }, [error, logger]);

  return <ErrorPage showButton={false} />;
};
